import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';
import { adminAuthAPI } from '../../services/apiService';
import Footer from '../../components/Footer';
import GoogleLoginButton from '../../components/GoogleLoginButton';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const data = await adminAuthAPI.login(formData);
      
      // Store admin token and auth status
      localStorage.setItem('adminToken', data.access_token);
      localStorage.setItem('isAdminAuthenticated', 'true');
      
      // Store admin user info
      const adminUser = {
        name: 'Admin',
        email: formData.email
      };
      localStorage.setItem('adminUser', JSON.stringify(adminUser));
      
      toast.success('Admin login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid admin credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-6">
      <Card className="w-full max-w-md shadow-2xl border-4 border-red-400 bg-white/90 backdrop-blur-sm">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{
              background: 'linear-gradient(135deg, #dc2626 0%, #f59e0b 100%)'
            }}>
              <Shield className="h-8 w-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold text-gray-900">Admin Panel</CardTitle>
          <CardDescription className="text-gray-600">Login to access admin dashboard</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-gray-700 font-semibold">Admin Email</Label>
              <Input
                id="email"
                name="email"
                type="email"
                placeholder="admin@netixfibernet.com"
                value={formData.email}
                onChange={handleChange}
                required
                className="h-12"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-gray-700 font-semibold">Password</Label>
              <Input
                id="password"
                name="password"
                type="password"
                placeholder="Enter admin password"
                value={formData.password}
                onChange={handleChange}
                required
                className="h-12"
              />
            </div>

            <Button 
              type="submit" 
              className="w-full h-12 text-lg font-bold text-white border-2 border-yellow-400 shadow-lg" 
              style={{ background: 'linear-gradient(135deg, #dc2626 0%, #f59e0b 100%)' }}
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Login as Admin'}
            </Button>
          </form>

          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <span className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="bg-white px-2 text-gray-500">Or continue with</span>
              </div>
            </div>
            
            <div className="mt-4">
              <GoogleLoginButton redirectPath="/admin/dashboard" />
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
          
            </p>
          </div>
        </CardContent>
      </Card>
      <Footer />
    </div>
  );
};

export default AdminLogin;
